import { getAdultBirthDate, transformKeys } from "@/utils";
import React from "react";
import moment from "moment";
import { useSearchParams } from "react-router-dom";

interface VerifierResultProps {
  presentationResult?: any;
  presentationRequestResult?: any;
  onClose?: () => void;
}

const VerifierResult: React.FC<VerifierResultProps> = ({
  presentationResult,
  // presentationRequestResult,
}) => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || "signup";

  const samplePresentation = presentationResult;

  const formatJsonData = (data: any) => {
    return JSON.stringify(data, null, 2);
  };

  const getExplanationContent = (type: string) => {
    switch (type) {
      case "signup":
        return {
          title: "본인인증 정보",
          description:
            "휴대폰 인증(ZKP)의 DID, 이름, 생년월일, 핸드폰 번호 데이터를 요청합니다.",
          buttonText: "인증 요청",
        };
      case "adult":
        return {
          title: "성인인증",
          description: `휴대폰 인증(ZKP)의 DID, 이름 데이터를 요청하고 생년월일을 통해 성인 여부를 확인합니다. \n\n 기준일 : ${moment().format(
            "YYYY년 MM월 DD일"
          )} \n성인 여부 조건 : 생년월일 <=${moment(
            getAdultBirthDate(18).toString()
          ).format("YYYY년 MM월 DD일")}`,
          buttonText: "인증 요청",
        };
      case "minor":
        return {
          title: "청소년인증",
          description: `휴대폰 인증(ZKP)의 DID, 이름 데이터를 요청하고 생년월일을 통해 청소년 여부를 확인합니다. \n\n 기준일 : ${moment().format(
            "YYYY년 MM월 DD일"
          )} \n청소년 여부 조건 : ${moment(
            getAdultBirthDate(18).toString()
          ).format("YYYY년 MM월 DD일")} < 생년월일 <= ${moment(
            getAdultBirthDate(9).toString()
          ).format("YYYY년 MM월 DD일")}`,
          buttonText: "인증 요청",
        };
      default:
        return {
          title: "VP SAMPLE",
          description: "Metadium DID 기반 인증 서비스를 테스트합니다.",
          buttonText: "인증 요청",
        };
    }
  };
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* 헤더 */}
      <header
        className="w-screen h-[88px] text-white bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/images/header_bg_low.png')",
        }}
      >
        <div className="flex items-center justify-between pt-6 pb-4 px-4">
          <img
            className="inline"
            src="/images/cplabs_logo.webp"
            width={100}
            height={20}
            alt="coinplug-logo"
          />
          <div className="flex items-center space-x-4">
            <div className="flex items-center justify-center w-12 h-12 bg-blue-600 rounded-full">
              <svg
                className="w-8 h-8 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <div className="text-right">
              <div className="text-xl font-bold">Success</div>
              <div className="text-sm opacity-90">Verification success</div>
            </div>
          </div>
        </div>
      </header>

      {/* 메인 컨텐츠 */}
      <div className="flex-1 flex">
        {/* 왼쪽 섹션 */}
        <div className="w-1/2 p-8 bg-white">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            {getExplanationContent(type)?.title || ""}
          </h1>
          <div className="text-gray-700 leading-relaxed space-y-4 whitespace-pre-line">
            {getExplanationContent(type)?.description || ""}
          </div>
        </div>

        {/* 오른쪽 섹션 */}
        <div className="w-1/2 p-8 bg-gray-50">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Presentation
          </h2>

          <div className="bg-gray-200 rounded-lg p-4 h-[500px] overflow-auto mb-4">
            <pre className="text-sm text-gray-800 whitespace-pre-wrap font-mono">
              {formatJsonData(samplePresentation)}
            </pre>
          </div>

          <div className="bg-gray-200 rounded-lg p-4 h-auto overflow-auto">
            <pre className="text-sm text-gray-800 whitespace-pre-wrap font-mono">
              {formatJsonData(
                transformKeys(
                  presentationResult.verifiableCredential[0].credentialSubject,
                  type as "signup" | "adult" | "minor"
                )
              )}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifierResult;
